<template>
    <div>
        <grid
            ref="grid"
            :is-auto-height="true"
            :is-auto-width="true"
            :auto-width-skip-header="false"
            :is-search="false"
            :row-data="value"
            :column-defs="columnDefs"
            :edit-auto-width-columns="editAutoWidthColumns"
            grid-theme="ag-theme-alpine-compact"
            :enableCellTextSelection="true"
            :overlayNoRowsTemplate="'<span></span>'"
            class="tech-info-table"
        ></grid>

        <span class="no-data" v-if="value.length == 0 && module == 'tax'">No {{ module }}es</span>
        <span class="no-data" v-if="value.length == 0 && module != 'tax'">No {{ module }}s</span>
        <span class="no-data add-one-time-fee" v-if="module == 'fee'"
            ><a href="javascript:void(0)" @click="addOneTimeFee()">Click to add a one time fee.</a></span
        >

        <modal :id="addModalId" :title="modalTitle" ok-title="Add" @ok="addItem()">
            <b-row>
                <b-col md="12">
                    <form-select :floating-label="modalLabel" v-model="selectedItem" :options="freeOptions" />
                </b-col>
            </b-row>
        </modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import API from '../../../../api';
    import isNil from 'lodash/isNil';
    import Grid from '../../../generic/grid/grid.vue';
    import Modal from '../../../generic/modal/modal.vue';
    import FormSelect from '../../../generic/form-select/form-select.vue';
    import AddItemButton from '../../../common/reservation-add-item-button.vue';
    import { invoiceMixin } from '../../mixins/invoice-mixin';
    import {
        RESERVATION_TECHRESERVATION_CHANGE_FEE_ENDPOINT,
        RESERVATION_TECHRESERVATION_ADD_DISCOUNT_ENDPOINT,
        RESERVATION_TECHRESERVATION_CHANGE_DEPOSIT_ENDPOINT,
        RESERVATION_TECHRESERVATION_CHANGE_TAX_ENDPOINT,
        RESERVATION_TECHRESERVATION_CHANGE_SERVICE_ENDPOINT,
    } from '../../../../endpoints';

    export default {
        name: 'TechInfoTable',
        components: {
            Grid,
            Modal,
            FormSelect,
            AddItemButton,
        },
        props: {
            value: {
                type: Array,
                default: () => [],
            },
            free: {
                type: Array,
                default: () => [],
            },
            reservationId: Number,
            metaReservationId: Number,
        },
        mixins: [invoiceMixin],
        computed: {
            ...mapGetters('header', ['userCurrencySymbol']),
            freeOptions() {
                return this.free.map((item) => ({
                    value: item.id,
                    text: item.title,
                }));
            },
        },
        data() {
            return {
                addModalId: '',
                modalTitle: '',
                modalLabel: '',
                method: '',
                selectedItem: null,
                editAutoWidthColumns: [],
            };
        },
        methods: {
            getRowId(item) {
                return item.data.id?.toString();
            },
            async addItem() {
                this.busy = true;
                try {
                    if (this.module == 'fee') {
                        await API.patch(RESERVATION_TECHRESERVATION_CHANGE_FEE_ENDPOINT(this.reservationId), {
                            fee_id: this.selectedItem,
                        });
                    } else if (this.module == 'discount') {
                        await API.patch(RESERVATION_TECHRESERVATION_ADD_DISCOUNT_ENDPOINT(this.reservationId), {
                            id: this.selectedItem,
                        });
                    } else if (this.module == 'deposit') {
                        await API.patch(RESERVATION_TECHRESERVATION_CHANGE_DEPOSIT_ENDPOINT(this.reservationId), {});
                    } else if (this.module == 'tax') {
                        await API.patch(RESERVATION_TECHRESERVATION_CHANGE_TAX_ENDPOINT(this.reservationId), {
                            tax_id: this.selectedItem,
                        });
                    } else if (this.module == 'service') {
                        await API.patch(RESERVATION_TECHRESERVATION_CHANGE_SERVICE_ENDPOINT(this.reservationId), {
                            service_id: this.selectedItem,
                        });
                    }

                    await this.refreshReservationInvoice(this.metaReservationId);
                } catch (e) {
                    console.log(e);
                    this.errorToast({ text: `Could not add ${this.module}.` });
                } finally {
                    this.busy = false;
                }
            },
            async deleteItem(id, URL) {
                this.busy = true;
                try {
                    await API.delete(URL(this.reservationId), {
                        data: { id: id },
                    });
                    await this.refreshReservationInvoice(this.metaReservationId);
                } catch (e) {
                    this.errorToast({ text: `Could not remove ${this.module}.` });
                } finally {
                    this.busy = false;
                }
            },
            async showAddItem() {
                if (this.freeOptions.length > 0) {
                    this.selectedItem = this.freeOptions[0].value;
                    this.$bvModal.show(this.addModalId);
                } else {
                    this.errorToast({ text: `No ${this.module} available.` });
                }
            },
        },
    };
</script>

<style lang="scss">
    .tech-info-table {
        .ag-root-wrapper {
            padding: 0 !important;
        }
        .tech-info-remove-item {
            text-align: center;

            .ag-cell-wrapper {
                .ag-cell-value {
                    overflow: visible;
                }
            }
        }

        .ag-header-row {
            background-color: #e8e8e8 !important;
        }
        .ag-root-wrapper {
            border-radius: 0;
        }

        .ag-header {
            border-width: 0 !important;
        }

        .ag-header-cell {
            padding-left: 20px !important;
            padding-right: 20px !important;
        }

        .ag-cell {
            padding-left: 20px !important;
            padding-right: 20px !important;
        }

        .ag-cell-inline-editing {
            padding-left: 0 !important;
            padding-right: 0 !important;
        }

        .lx-yes-no-cell {
            opacity: 0.7;

            .ag-cell-wrapper {
                .ag-cell-value span button {
                    cursor: default !important;
                }
            }
        }
    }
</style>
